import React from 'react';

import { FORMS } from '../../schemas/stepMap';
import InvestmentCriteriaOverview from '../../components/property-summaries/InvestmentCriteriaOverview';

export default function PurchaseInvestmentCriteria({ propertyData = {} }) {
  const { purchaseWorksheetSubmitted } = propertyData || {};

  return (
    <InvestmentCriteriaOverview
      schema={FORMS.purchaseAnalysis.investmentMetrics}
      data={propertyData}
      type="overview"
      disabled={!purchaseWorksheetSubmitted}
    />
  );
}
